import React, { useState, useEffect, useMemo } from "react";
import { withRouter } from "react-router-dom";
import config from "../../config";
import { Grid, Typography } from "@mui/material";
import { trackPage } from "../../analytics";
import colors from "../../assets/colors";
import { SignupCard, CtaButton, StepHeader } from "../../signupComponents";
import EasyRadio from "../../common/components/EasyForm/EasyRadio";

// 👇 from MUI v4
import withStyles from "@material-ui/core/styles/withStyles";

const withSignupEventCode = (path, signupEventCode) =>
  signupEventCode
    ? `${path}?signupEventCode=${encodeURIComponent(signupEventCode)}`
    : path;

const styles = theme => ({
  heroContainer: {
    maxWidth: 860,
    width: "92%",
    textAlign: "center",
    marginTop: theme.spacing(3)
  },
  heroTitle: {
    fontFamily: '"Ubuntu","Helvetica","Arial",sans-serif !important',
    fontWeight: 800,
    fontSize: 32,
    lineHeight: 1.22,
    letterSpacing: 0.2,
    color: colors.mcsdark,
    textAlign: "center",
    marginBottom: theme.spacing(1)
  },
  heroSubtitle: {
    fontFamily: '"Ubuntu","Helvetica","Arial",sans-serif !important',
    fontWeight: 400,
    fontSize: 18,
    textAlign: "center",
    color: colors.mcsdark,
    marginBottom: theme.spacing(1.25)
  },
  heroBody: {
    fontFamily: '"Ubuntu","Helvetica","Arial",sans-serif !important',
    fontWeight: 500,
    fontSize: 14,
    color: colors.softblack,
    textAlign: "center",
    marginBottom: theme.spacing(2.5)
  }
});

const Home = props => {
  const { classes } = props;
  const [choice, setChoice] = useState("");

  useEffect(() => {
    trackPage("home");
  }, []);

  const goNext = () => {
    if (!choice) return;

    const path =
      choice === "inside"
        ? config.SIGNUP.APP_PATH + "/inside"
        : config.SIGNUP.APP_PATH + "/outside";

    props.setSignupclass(choice);

    props.history.push(withSignupEventCode(path, props.signupEventCode));
  };

  // fake connectForm for EasyRadio
  const easyRadioConnectForm = useMemo(() => {
    const options = [["inside", "Inside"], ["outside", "Outside"]];

    return {
      getDropdownOptions: () => options,
      getValue: () => choice,
      change: value => setChoice(value),
      setPropMounted: () => {},
      isRequired: () => false,
      getLabel: () => ""
    };
  }, [choice]);

  return (
    <Grid container justifyContent="center" sx={{ width: "100%" }}>
      <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: { xs: 2, md: 3 }
        }}
      >
        {/* Intro */}
        <Grid item className={classes.heroContainer}>
          <Typography component="h1" className={classes.heroTitle}>
            Ready To Enjoy High-Speed And Reliable Internet Built For Your
            Needs?
          </Typography>

          <Typography className={classes.heroSubtitle}>
            Find out if MCSnet internet service is available in your
            neighbourhood.
          </Typography>

          <Typography className={classes.heroBody}>
            Fill out our quick and easy form, and we will get back to you with
            availability and the best internet option and package most suitable
            for you or your business.
          </Typography>
        </Grid>

        {/* Card */}
        <Grid
          item
          sx={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          <SignupCard size="xl" maxw={860}>
            <StepHeader
              step={1}
              eyebrow="What is your location?"
              title="Do you reside inside of a town, city, village, hamlet, summer village or subdivision?"
            />

            <Grid item xs={12} sx={{ mt: 1, mb: 3 }}>
              <EasyRadio
                propName="homeLocationChoice"
                connectForm={easyRadioConnectForm}
              />
            </Grid>

            <Grid container justifyContent="flex-end">
              <CtaButton
                variant="contained"
                disabled={!choice}
                onClick={goNext}
              >
                NEXT STEP
              </CtaButton>
            </Grid>
          </SignupCard>
        </Grid>
      </Grid>
    </Grid>
  );
};

// 👇 wrap with withStyles AND withRouter
export default withStyles(styles)(withRouter(Home));
